import { Component, input } from '@angular/core';

type MemberAvatarType = 'channel' | 'user';
type MemberAvatarSize = 'normal' | 'small' | 'medium';

@Component({
  selector: 'app-member-avatar',
  templateUrl: './member-avatar.component.html',
  styleUrls: ['./member-avatar.component.scss'],
})
export class MemberAvatarComponent {
  logo = input<string>();
  type = input<MemberAvatarType>('channel');
  size = input<MemberAvatarSize>('normal');

  get logoClass(): string {
    return `logo ${this.type()} ${this.size()}`;
  }

  get backgroundImageStyles() {
    return {
      backgroundImage: `url(${this.logo()})`,
    };
  }
}
